function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function HalfDialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 26",
    fill: "none",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.324 18.093a2.23 2.23 0 1 1-4.46-.001 2.23 2.23 0 0 1 4.46.001Zm-.654-1.576 7.36-7.356M3.973 18.837h2.972m25.27.001-2.973-.001M18.094 3.972v2.973M8.11 8.109l2.1 2.103",
    stroke: "#2B7D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.094 1C8.652 1 1 8.654 1 18.094v6.689h34.188v-6.69C35.188 8.654 27.535 1 18.093 1Z",
    stroke: "#2B7D82"
  }));
}
export default HalfDialIcon;
//# sourceMappingURL=HalfDial.js.map